'use client'

/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-misused-promises */
import { useEnvVariablesClientConfig } from '@context/EnvClientContext/EnvVariablesClientContext'
import { useState, useEffect } from 'react'
import Cookies from 'js-cookie'
import growthBook from '@components/utils/growthbook'
import { GrowthBookProvider } from '@growthbook/growthbook-react'
import ChallanRtoWidget from './ChallanWidgetGrowthbookEnabled'

interface ChallanRtoWidgetProps {
  widget: string
  widgetHeading?: string
  regexPatternsData?: object
  widgetCtaText?: string
  inputPlaceholder?: string
  isMobileDevice: boolean
  challanFinalScreenData: object
  widgetOptions: any
  segmentEventCommonProperties?: object
  isBottomFloater: boolean
  onHide: Function
}

const ChallanRtoWidgetWithGrowthBook: React.FC<ChallanRtoWidgetProps> = props => {
  const config = useEnvVariablesClientConfig()
  const currentEnv = config?.ACKO_ENV
  const [growthBookConfig, setGrowthBook] = useState<any>()

  useEffect(() => {
    if (config) {
      const newGrowthBookConfig = growthBook(currentEnv)
      newGrowthBookConfig.loadFeatures()
      newGrowthBookConfig.setAttributes({ deviceId: Cookies.get('trackerid') })
      setGrowthBook(newGrowthBookConfig)
    }
  }, [config, currentEnv])

  return (
    <GrowthBookProvider growthbook={growthBookConfig}>
      <ChallanRtoWidget {...props} />
    </GrowthBookProvider>
  )
}

export default ChallanRtoWidgetWithGrowthBook
